/* src/app/features/honra/consulta-ipoc/consulta-ipoc-pesquisa.component.scss */
.pesquisa {
  margin-bottom: 40px;
}
/*# sourceMappingURL=consulta-ipoc-pesquisa.component.css.map */
